import { debounce } from '../../core/helpers';

// Filter nav sticks to the main nav after scrolling to a certain position
const filterNavPosition = () => {
  if (!$('[data-collection-grid]').data('filter-bar-fixed')) {
    return;
  }

  const $filters_panel = $('[data-filters-panel-v2]');
  const $nav = $('[data-main-nav]');
  const $full_header = $('.shopify-section.header .main-nav--desktop');
  const $products_element = $('[data-products]');

  if (!$filters_panel.length || !$nav.length || !$full_header.length || !$products_element.length) {
    return;
  }

  const window_top = $(window).scrollTop();
  const nav_height = $nav.outerHeight();
  // const panels_position = $filters_panel.offset().top;
  // const products_top = $products_element.offset().top + $filters_panel.position().top;
  const products_top = $products_element.offset().top;

  /*
  if (products_top - nav_height <= window_top) {
    if ($full_header.hasClass('header-hidden')) {
      $filters_panel.removeClass('sticky--header');
      $filters_panel.addClass('sticky');
      $products_element.css('padding-top', $('[data-filters-panel-v2]').outerHeight()); // avoid the jump effect
    } else {
      $filters_panel.addClass('sticky--header');
    }
  } else {
    $filters_panel.removeClass('sticky--header');
    $filters_panel.removeClass('sticky');
    $products_element.css('padding-top', '0');
  }
  */
  if (products_top - nav_height <= window_top) {
    $filters_panel.addClass('sticky');
    $products_element.css('padding-top', $('[data-filters-panel-v2]').outerHeight()); // avoid the jump effect
  } else {
    $filters_panel.removeClass('sticky');
    $products_element.css('padding-top', '0');
  }

  // console.log(panels_position, products_top, window_top);
};

export default () => {
  const collection_grid = document.querySelector('[data-collection-grid]');

  if (collection_grid?.dataset.filterBarFixed === 'true') {
    // Keep the filter nav sticky below the main nav
    window.addEventListener('scroll', () => {
      filterNavPosition();
    });

    // Stop scrolling
    window.addEventListener('scroll', debounce(() => {
      filterNavPosition();
    }, 100));

    // From mobile to desktop
    window.addEventListener('resize', debounce(() => {
      filterNavPosition();
    }, 100));

    window.dispatchEvent(new Event('scroll'));
  }
};
